import type {
	AlertBoxActionEnum,
	AlertBoxActionStateEnum,
	PortfolioAlertBoxDTO,
} from "web_myplann/Infrastructure/Api/Api";

/**
 * Returns a copy of the alert with the given (action, state) recorded as
 * performed, for eagerly patching the query cache after a mutation succeeds.
 *
 * Only the matching (action, state) entry is replaced — so its `performedAt`
 * refreshes on a repeat, but any *other* state already recorded for the same
 * action is preserved. This lets `parseAlertActionStates`' precedence
 * (Sent > Opened) remain the single source of truth for which state renders, so
 * a later fallback `Opened` can never optimistically downgrade an existing
 * `Sent`. The authoritative `performedAt` is reconciled from the backend on the
 * next refetch.
 */
export const withPerformedAction = (
	alert: PortfolioAlertBoxDTO,
	action: AlertBoxActionEnum,
	state: AlertBoxActionStateEnum,
): PortfolioAlertBoxDTO => ({
	...alert,
	performedActions: [
		...alert.performedActions.filter(
			(performedAction) =>
				!(performedAction.action === action && performedAction.state === state),
		),
		{ action, state, performedAt: new Date().toISOString() },
	],
});
